module.exports = __webpack_public_path__ + "static/media/Partner-LogosDharmawangsa.0921e43a.png";